<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"> </p>
<p class="copy"><span class="red">Publisher:</span> Amy Marson</p>
<p class="copy"><span class="red">Creative Director:</span> Gailen Runge</p>
<p class="copy"><span class="red">Acquisitions Editor:</span> Roxane Cerda</p>
<p class="copy"><span class="red">Managing Editor:</span> Liz Aneloski</p>
<p class="copy"><span class="red">Technical Editor:</span> Gailen Runge</p>
<p class="copy"><span class="red">Cover/Book Designer:</span> April Mostek</p>
<p class="copy"><span class="red">Production Coordinator:</span> Zinnia Heinzmann</p>
<p class="copy"><span class="red">Production Editor:</span> Alice Mace Nakanishi</p>
<p class="copy"><span class="red">Illustrator:</span> Linda Johnson</p>
<p class="copy"><span class="red">Photo Assistant:</span> Mai Yong Vang</p>
<p class="copy"><span class="red">Cover photography</span> by Lucy Glover</p>
<p class="copy"><span class="red">Subject photography</span> by Lucy Glover and <br/><span class="red">instructional photography</span> by Mai Yong Vang of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="copy">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
<p class="copy"><img alt="" src="images/pg3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copy.vue?49cdf863